import React, { Component } from 'react';
import '../../styles/devices.css';

class TerminalDetails extends Component {
    render() {
        const { details } = this.props;

        return (
            <div>
                <h2>Terminal Details</h2>
                <div className="card-slim">
                    <h3 className="m-t-0 m-b-5 text-center">{details.terminalID}</h3>
                    <div className={"device " + (details.model || "").toLowerCase()} />
                    <table className="table table-striped m-t-10 m-b-0">
                        <tbody>
                            <tr>
                                <th>Make</th>
                                <td>{details.maker}</td>
                            </tr>
                            <tr>
                                <th>Model</th>
                                <td>{details.model}</td>
                            </tr>
                            <tr>
                                <th>Type</th>
                                <td>{details.device}</td>
                            </tr>
                            <tr>
                                <th>MMD</th>
                                <td>{details.mmD_ID}</td>
                            </tr>
                            <tr>
                                <th>Serial No.</th>
                                <td>{details.serial.trim()}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default TerminalDetails;


// WEBPACK FOOTER //
// ./app/terminals/components/terminalDetails.js